import React, { useEffect, useState } from 'react';
import { Form, Select, Table } from 'tdesign-react';
import { useMemoizedFn } from 'ahooks';
import styled from 'styled-components';
import useTable from '@/hooks/useTable';
import { getMessageList, getTopicPartitionList } from '@/services/kopTopicService';
import { renderMillDateTime, sleep, toTsOptions } from '@/utils/common';
import { offsetPositionOptions } from '@/utils/constant';
import TruncationAppend from './TruncationAppend';

const { FormItem } = Form;

export default function Message({ commonProps }) {
  const [isTruncation, setIsTruncation] = useState(true);
  const [partitionOptions, setPartitionOptions] = useState([]);
  const columns = [
    {
      title: 'Partition',
      colKey: 'partition',
      width: 100,
      fixed: 'left',
    },
    {
      title: 'Offset',
      colKey: 'offset',
      width: 120,
    },
    {
      title: 'Timestamp',
      colKey: 'timestamp',
      cell: renderMillDateTime,
      width: 210,
    },
    {
      title: 'Key',
      colKey: 'key',
      width: 100,
    },
    {
      title: 'Value',
      colKey: 'value',
    },
    {
      title: 'Header',
      colKey: 'header',
    },
  ];

  const loadData = useMemoizedFn(async (params) => {
    const { data } = await getMessageList({
      ...params,
      clusterName: commonProps.clusterName,
      topic: commonProps.topic,
      isTruncation,
    });
    setData(data);
  });

  const loadPartitions = useMemoizedFn(async (params) => {
    const {
      data: { kopTopicPartitionMetricsList },
    } = await getTopicPartitionList({
      ...params,
      clusterName: commonProps.clusterName,
      topic: commonProps.topic,
    });
    setPartitionOptions(
      kopTopicPartitionMetricsList.map((item) => ({
        label: `${item.partition}`,
        value: item.partition,
      })),
    );
  });

  const onTruncationChange = async (value) => {
    setIsTruncation(value);
    await sleep(30);
    doSearch(null, true);
  };

  const { header, setData, doSearch, config } = useTable({
    columns,
    onSearch: loadData,
    search: (
      <>
        <FormItem name='offsetPosition' initialData={'latest'}>
          <Select placeholder='请选择offset' options={toTsOptions(offsetPositionOptions)} />
        </FormItem>
        <FormItem name='partition'>
          <Select placeholder='请选择分区' options={toTsOptions(partitionOptions)} clearable />
        </FormItem>
      </>
    ),
    append: <TruncationAppend value={isTruncation} onChange={onTruncationChange} />,
  });

  useEffect(() => {
    loadPartitions();
    doSearch({
      offsetPosition: 'latest',
    });
  }, [doSearch, loadPartitions]);

  return (
    <Root>
      {header}
      <Table {...config} />
    </Root>
  );
}

const Root = styled.div`
  padding-top: 18px;
`;
